import React from "react";
import PromiseModal from "./PromiseModal";

export default class AlertModal extends PromiseModal {
  renderBody() {
    return (
      <div className="modal-container">
        <div className="modal">
          <form onSubmit={(e) => { e.preventDefault(); this.resolve(this.state); }}>
            <h3>{this.state.title}</h3>
            <p dangerouslySetInnerHTML={{__html: this.state.message}} />
            <input className="button-primary" type="submit" value="OK" />
          </form>
        </div>
      </div>
    );
  }
}
